import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/')({
  validateSearch: zodValidator(withDefaults(schema.LOOKUP_TABLES, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.LOOKUP_TABLES,
      permission: Permission.CREATE,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
